module.exports = __webpack_public_path__ + "img/event_default.80b89f77.svg";